import { render } from "./BuildingsView.vue?vue&type=template&id=eae70b6e&scoped=true"
import script from "./BuildingsView.vue?vue&type=script&lang=js"
export * from "./BuildingsView.vue?vue&type=script&lang=js"

import "./BuildingsView.vue?vue&type=style&index=0&id=eae70b6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eae70b6e"]])

export default __exports__